import {
  ref,
} from "vue";

export default function UpdateModelAPI({
  modelColumnsVisible = ref({}),
  modelColumnsOrderingLocal = ref([]),
  modelIsTableWithoutScrollStartLocal = ref(true),
  saveTableOptions = () => {},
}) {
  const changeModelColumnsVisible = modelColumnsVisibleArg => {
    modelColumnsVisible.value = modelColumnsVisibleArg;
    saveTableOptions();
  };

  const changeColumnsOrdering = ({ modelColumnsOrdering }) => {
    modelColumnsOrderingLocal.value = modelColumnsOrdering;
    saveTableOptions();
  };

  const updateModelIsTableWithoutScroll = model => {
    modelIsTableWithoutScrollStartLocal.value = model;
    saveTableOptions();
  };

  return {
    changeModelColumnsVisible,
    changeColumnsOrdering,
    updateModelIsTableWithoutScroll,
  };
}
